// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_COMPLAINT_TITLE = "Nahlasujem nevhodn\u00fd \u010dl\u00e1nok";
export const ARTICLE_DELETED_BY_ADMIN = "\u010cl\u00e1nok zmazan\u00fd adminom";
export const ARTICLE_DELETED_BY_AUTHOR = "\u010cl\u00e1nok zmazan\u00fd autorom";
export const ARTICLE_DELETED_BY_MODERATOR = "\u010cl\u00e1nok zmazan\u00fd moder\u00e1torkou";
export const BACK_TO_BLOGS = "Sp\u00e4\u0165 na pr\u00edspevky";
export const MORE_ARTICLE_SECTIONS = "\u010eal\u0161ie rubriky \u010dl\u00e1nkov";
export const PB_RECOMMENDED_ARTICLES = "Odpor\u00fa\u010dame";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
export const RELATED_BLOG_ARTICLES = "Podobn\u00e9 \u010dl\u00e1nky";
export const STROLLEROPEDIA_MORE_ARTICLES = "Zobraz \u010fal\u0161ie \u010dl\u00e1nky";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
